import { resolve, reject } from 'redux-optimist-promise';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { getTravelSectionSummary } from 'Utils/label/labelUtils';
import { CITIES_GET_TRANSPORT_STATIONS } from 'Utils/request/requestDictionary';
import createAction from 'Store/utils/createAction';

export const FETCH_TRANSPORT_STATIONS = 'FETCH_TRANSPORT_STATIONS';

const formatTransportStationsNames = (node) => {
  return node.map((transport) => ({
    value: transport.id,
    label: transport.label,
    name: getTravelSectionSummary({
      travelSection: transport,
    }),
  }));
};

const transportStationFragment = `
    fragment transportStation on TransportStationType {
      id
      label
      city_id
      type
      is_main_city_station
    }`;

function fetchTransportStationsQuery(cityId, appContext) {
  const query = `{
      transportStations(cityId: "${cityId}"){
        airports {
          ...transportStation
        }
        trainStations {
          ...transportStation
        }
        ports {
          ...transportStation
        }
      }
    }
    ${transportStationFragment}`;

  return graphQLClient
    .runNoCacheQuery(query, appContext, {
      requestName: CITIES_GET_TRANSPORT_STATIONS,
    })
    .then(({ transportStations: { airports, trainStations, ports } }) => ({
      airports: formatTransportStationsNames(airports),
      trainStations: formatTransportStationsNames(trainStations),
      ports: formatTransportStationsNames(ports),
    }));
}

function fetchTransportStations(cityId, appContext) {
  return (dispatch) => {
    dispatch(createAction(FETCH_TRANSPORT_STATIONS, cityId));
    return fetchTransportStationsQuery(cityId, appContext)
      .then((response) => {
        dispatch(createAction(resolve(FETCH_TRANSPORT_STATIONS), response));
        return response;
      })
      .catch((error) => {
        dispatch(createAction(reject(FETCH_TRANSPORT_STATIONS)));
        throw error;
      });
  };
}

export { fetchTransportStations };
